import { shape, object, arrayOf, oneOfType, string, number } from 'prop-types';
import { CategoryPropType } from 'Types/categories';

export const FilterValuesPropType = shape({
  valueId: number,
  value: oneOfType([number, string]),
  slug: string,
  count: number
});

export const FilterPropType = shape({
  nameId: number,
  name: string,
  slug: string,
  values: arrayOf(FilterValuesPropType)
});

const FiltersPropType = shape({
  categories: arrayOf(shape({
    count: number,
    id: number.isRequired,
    name: string.isRequired
  })),
  properties: arrayOf(FilterPropType),
  manufacturers: arrayOf(shape({
    count: number,
    id: string.isRequired,
    name: string.isRequired
  }))
});

export const ActiveFiltersPropType = shape({
  category: CategoryPropType,
  brands: arrayOf(object),
  [string]: oneOfType([arrayOf(object), object, string])
});

export default FiltersPropType;
